var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhileReadingQuestionExploreIt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4384_30329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0007 3C16.8745 3 14.2486 3.16533 12.0841 3.64637C9.90068 4.13162 8.08592 4.96 6.68995 6.35597C5.29398 7.75193 4.4656 9.5667 3.98035 11.7501C3.49932 13.9146 3.33398 16.5405 3.33398 19.6667C3.33398 22.7928 3.49932 25.4187 3.98035 27.5832C4.4656 29.7667 5.29398 31.5813 6.68995 32.9773C8.08592 34.3733 9.90068 35.2017 12.0841 35.687C14.2486 36.168 16.8745 36.3333 20.0007 36.3333C23.1268 36.3333 25.7527 36.168 27.9172 35.687C30.1007 35.2017 31.9153 34.3733 33.3113 32.9773C34.7073 31.5813 35.5357 29.7667 36.021 27.5832C36.502 25.4187 36.6673 22.7928 36.6673 19.6667C36.6673 16.5405 36.502 13.9146 36.021 11.7501C35.5357 9.5667 34.7073 7.75193 33.3113 6.35597C31.9153 4.96 30.1007 4.13162 27.9172 3.64637C25.7527 3.16533 23.1268 3 20.0007 3Z",
    fill: "url(#paint0_linear_4384_30329)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_4384_30329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0007 4C16.8974 4 14.3581 4.1654 12.301 4.62255C10.2363 5.08142 8.61713 5.843 7.39706 7.06307C6.17699 8.28314 5.4154 9.90235 4.95654 11.9671C4.49939 14.0241 4.33398 16.5634 4.33398 19.6667C4.33398 22.7699 4.49939 25.3092 4.95653 27.3662L3.98035 27.5832C3.49932 25.4187 3.33398 22.7928 3.33398 19.6667C3.33398 16.5405 3.49932 13.9146 3.98035 11.7501C4.4656 9.5667 5.29398 7.75193 6.68995 6.35597C8.08592 4.96 9.90068 4.13162 12.0841 3.64637C14.2486 3.16533 16.8745 3 20.0007 3C23.1268 3 25.7527 3.16533 27.9172 3.64637L27.7002 4.62255C25.6432 4.1654 23.1039 4 20.0007 4ZM35.0448 11.9671C34.5859 9.90234 33.8243 8.28314 32.6042 7.06308C31.3841 5.843 29.765 5.08142 27.7002 4.62255L27.9172 3.64637C30.1007 4.13162 31.9153 4.96 33.3113 6.35597C34.7073 7.75193 35.5357 9.5667 36.021 11.7501C36.502 13.9146 36.6673 16.5405 36.6673 19.6667C36.6673 22.7928 36.502 25.4187 36.021 27.5832C35.5357 29.7667 34.7073 31.5813 33.3113 32.9773C31.9153 34.3733 30.1007 35.2017 27.9172 35.687C25.7527 36.168 23.1268 36.3333 20.0007 36.3333C16.8745 36.3333 14.2486 36.168 12.0841 35.687C9.90068 35.2017 8.08592 34.3733 6.68995 32.9773C5.29398 31.5813 4.4656 29.7667 3.98035 27.5832L4.95654 27.3662C5.4154 29.431 6.17698 31.0501 7.39707 32.2702C8.61713 33.4903 10.2363 34.2519 12.3011 34.7108C14.3581 35.1679 16.8974 35.3333 20.0007 35.3333C23.1039 35.3333 25.6432 35.1679 27.7002 34.7108C29.765 34.2519 31.3841 33.4903 32.6042 32.2702C33.8243 31.0501 34.5859 29.431 35.0448 27.3662C35.5019 25.3092 35.6673 22.7699 35.6673 19.6667C35.6673 16.5635 35.5019 14.0241 35.0448 11.9671Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_4384_30329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9802 21.2074H16.9405L17.9259 22.4751L18.8954 23.6044L20.7224 25.8949H18.5704L17.3133 24.3501L16.6688 23.4339L14.9802 21.2074ZM20.8876 19.5455C20.8876 20.7351 20.6621 21.7472 20.2111 22.5817C19.7636 23.4162 19.1528 24.0536 18.3787 24.494C17.6081 24.9308 16.7416 25.1491 15.7793 25.1491C14.8098 25.1491 13.9398 24.929 13.1692 24.4886C12.3986 24.0483 11.7896 23.4109 11.3421 22.5763C10.8947 21.7418 10.6709 20.7315 10.6709 19.5455C10.6709 18.3558 10.8947 17.3438 11.3421 16.5092C11.7896 15.6747 12.3986 15.0391 13.1692 14.6023C13.9398 14.1619 14.8098 13.9418 15.7793 13.9418C16.7416 13.9418 17.6081 14.1619 18.3787 14.6023C19.1528 15.0391 19.7636 15.6747 20.2111 16.5092C20.6621 17.3438 20.8876 18.3558 20.8876 19.5455ZM18.5491 19.5455C18.5491 18.7749 18.4337 18.125 18.2029 17.5959C17.9756 17.0668 17.6543 16.6655 17.2388 16.392C16.8233 16.1186 16.3368 15.9819 15.7793 15.9819C15.2217 15.9819 14.7352 16.1186 14.3197 16.392C13.9043 16.6655 13.5811 17.0668 13.3503 17.5959C13.123 18.125 13.0094 18.7749 13.0094 19.5455C13.0094 20.3161 13.123 20.9659 13.3503 21.495C13.5811 22.0241 13.9043 22.4254 14.3197 22.6989C14.7352 22.9723 15.2217 23.109 15.7793 23.109C16.3368 23.109 16.8233 22.9723 17.2388 22.6989C17.6543 22.4254 17.9756 22.0241 18.2029 21.495C18.4337 20.9659 18.5491 20.3161 18.5491 19.5455ZM24.5031 21.7294V21.5483C24.5066 20.9268 24.5617 20.4315 24.6682 20.0621C24.7783 19.6928 24.9381 19.3945 25.1476 19.1673C25.3571 18.94 25.6092 18.734 25.904 18.5494C26.1242 18.4073 26.3212 18.2599 26.4953 18.1072C26.6693 17.9545 26.8078 17.7859 26.9107 17.6012C27.0137 17.413 27.0652 17.2035 27.0652 16.9727C27.0652 16.7276 27.0066 16.5128 26.8894 16.3281C26.7722 16.1435 26.6142 16.0014 26.4153 15.902C26.22 15.8026 26.0034 15.7528 25.7655 15.7528C25.5347 15.7528 25.3163 15.8043 25.1103 15.9073C24.9043 16.0067 24.7357 16.1559 24.6043 16.3548C24.4729 16.5501 24.4019 16.7933 24.3912 17.0845H22.2179C22.2357 16.3743 22.4061 15.7884 22.7293 15.3267C23.0524 14.8615 23.4803 14.5153 24.013 14.288C24.5457 14.0572 25.1334 13.9418 25.7761 13.9418C26.4828 13.9418 27.1078 14.0589 27.6511 14.2933C28.1945 14.5241 28.6206 14.8597 28.9296 15.3001C29.2385 15.7404 29.393 16.2713 29.393 16.8928C29.393 17.3082 29.3237 17.6776 29.1852 18.0007C29.0503 18.3203 28.8603 18.6044 28.6153 18.853C28.3703 19.098 28.0808 19.32 27.747 19.5188C27.4665 19.6857 27.2357 19.8597 27.0546 20.0408C26.877 20.2219 26.7438 20.4315 26.6551 20.6694C26.5698 20.9073 26.5254 21.2003 26.5219 21.5483V21.7294H24.5031ZM25.5578 25.1385C25.2026 25.1385 24.899 25.0142 24.6469 24.7656C24.3983 24.5135 24.2758 24.2116 24.2793 23.8601C24.2758 23.5121 24.3983 23.2138 24.6469 22.9652C24.899 22.7166 25.2026 22.5923 25.5578 22.5923C25.8951 22.5923 26.1916 22.7166 26.4473 22.9652C26.703 23.2138 26.8326 23.5121 26.8362 23.8601C26.8326 24.0945 26.7705 24.3093 26.6497 24.5046C26.5325 24.6964 26.3781 24.8509 26.1863 24.968C25.9945 25.0817 25.785 25.1385 25.5578 25.1385Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4384_30329",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_4384_30329",
    x: 1.33398,
    y: 1,
    width: 37.3333,
    height: 37.3334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_4384_30329",
    x: 8.23727,
    y: 13.9418,
    width: 23.5894,
    height: 16.8204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.43366
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.21683
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4384_30329"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4384_30329",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4384_30329",
    x1: 20.0007,
    y1: 3,
    x2: 20.0007,
    y2: 36.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E62679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#B7004F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhileReadingQuestionExploreIt);
export default __webpack_public_path__ + "static/media/WhileReadingQuestionExploreIt.209810003a2af455f0395220b17e739c.svg";
export { ForwardRef as ReactComponent };